let sdkPromise = null;

// Prepare Google's consent integration before IMA requests a preroll. Loading
// GPT does not define a slot or authorize an ad request.
export function loadGooglePublisherSdk() {
  if (typeof window === 'undefined') return Promise.reject(new Error('GPT requires a browser'));
  if (window.googletag?.apiReady) return Promise.resolve(window.googletag);
  if (sdkPromise) return sdkPromise;
  window.googletag = window.googletag || { cmd: [] };
  sdkPromise = new Promise((resolve, reject) => {
    let script = document.querySelector('script[data-watchvim-gpt-sdk="true"]');
    const timer = window.setTimeout(() => fail(), 10000);
    const cleanup = () => {
      window.clearTimeout(timer);
      script?.removeEventListener('error', fail);
    };
    const fail = () => {
      cleanup();
      script?.remove();
      reject(Object.assign(new Error('Google Publisher Tag failed to load'), { code: 'WATCHVIM_GPT_LOAD_FAILED' }));
    };
    window.googletag.cmd.push(() => {
      cleanup();
      window.googletag.setConfig({ disableInitialLoad: true });
      resolve(window.googletag);
    });
    if (!script) {
      script = document.createElement('script');
      script.async = true;
      script.crossOrigin = 'anonymous';
      script.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
      script.dataset.watchvimGptSdk = 'true';
      script.addEventListener('error', fail, { once: true });
      document.head.appendChild(script);
    } else script.addEventListener('error', fail, { once: true });
  }).catch((error) => {
    sdkPromise = null;
    throw error;
  });
  return sdkPromise;
}
